"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserAuthorityPreference = exports.getUserAuthority = void 0;

var _index = _interopRequireDefault(require("../index"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var getUserAuthority = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url) {
    var response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            console.log("url", url);
            _context.next = 3;
            return _index.default.get("".concat(url, "/api/Authority/UserProfile")).then(function (res) {
              return res;
            }).catch(function (error) {
              return {
                isSuccess: false,
                data: error.data
              };
            });

          case 3:
            response = _context.sent;
            console.log("responseresponse", response);
            return _context.abrupt("return", response);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getUserAuthority(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.getUserAuthority = getUserAuthority;

var getUserAuthorityPreference = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url, payload) {
    var type, data, response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            type = payload.type, data = payload.data;
            _context2.next = 3;
            return _index.default.post("".concat(url, "/api/Authority/Preference/").concat(type), data);

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getUserAuthorityPreference(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

exports.getUserAuthorityPreference = getUserAuthorityPreference;